import angular from 'angular'
import locklessService from './lockless.service'
import dataUILinker from './dataUILinker.service'

export default angular
  .module('ellipsis.lockless', [])
  .service('locklessService', locklessService)
  .service('dataUILinkerService', dataUILinker)
